// extracted by mini-css-extract-plugin
export default {"skipLink":"IFBMHD","skipLink__spacing":"wWQShv"};